import {Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import {SyncService} from '../../shared/services/sync.service';
import {PrintNoticeData} from '../../shared/models/print';
import {AbstractPrintComponent} from '../abstract-print/abstract-print.component';

// Base layer: generic refused-entry notice. Projects override this template via angular.json fileReplacements (see VISA-ZIM/print-notice-refusal).
@Component({
  selector: 'app-print-notice-refusal',
  template: `
<div id="print">
  <div class="print_content">
    <div class="text_center mb_20">
      <h2>{{'notice.REFUSAL' | translate}}</h2>
      <p>{{'notice.desc.REFUSAL' | translate}}</p>
    </div>
    <table class="notice-table">
      <tbody>
        <tr *ngIf="data.form.controls.fullNames">
          <td><b>{{'form.fullNames' | translate}}</b></td>
          <td>{{data.form.controls.fullNames.value}}</td>
        </tr>
        <tr *ngIf="data.form.controls.reportLocation">
          <td><b>{{'form.reportLocation' | translate}}</b></td>
          <td>{{data.form.controls.reportLocation.value}}</td>
        </tr>
        <tr *ngIf="data.form.controls.reason">
          <td><b>{{'form.reason' | translate}}</b></td>
          <td>{{data.form.controls.reason.value}}</td>
        </tr>
        <tr *ngIf="data.form.controls.dateOfRefusal">
          <td><b>{{'form.dateOfRefusal' | translate}}</b></td>
          <td>{{data.form.controls.dateOfRefusal.value | date: 'dd/MM/yyyy'}}</td>
        </tr>
        <tr *ngIf="data.form.controls.place">
          <td><b>{{'form.place' | translate}}</b></td>
          <td>{{data.form.controls.place.value}}</td>
        </tr>
        <tr *ngIf="data.form.controls.officer">
          <td><b>{{'form.officer' | translate}}</b></td>
          <td>{{sync.userDisplay(data.form.controls.officer.value)}} #{{data.form.controls.officer.value}}</td>
        </tr>
        <tr *ngIf="data.form.controls.operationComments?.value">
          <td><b>{{'form.operationComments' | translate}}</b></td>
          <td>{{data.form.controls.operationComments.value}}</td>
        </tr>
      </tbody>
    </table>
    <div class="flex f_between f_align_end mt_20">
      <p>{{'notice.acknowledge' | translate}}</p>
      <qrcode *ngIf="data.qrCode" elementType="img" [qrdata]="data.qrCode" [margin]="0"></qrcode>
    </div>
  </div>
</div>
  `,
  styles: `
@media print {
  body, html{
    overflow: auto !important;
    height: auto !important;
    width:  auto !important;
  }
}

#print {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999;
  height: 100%;
  width: 100%;
  display: none;
  justify-content: center;
  background: white;
  color: black;
  padding: 2% 8%;
  overflow: auto;
  font-size: 12px;
  line-height: 1.3;

  .print_content {
    counter-reset: page;
    margin: 0 auto;
    width: 600px;
  }

  .notice-table {
    width: 100%;
    border-collapse: collapse;

    td {
      border: 1px solid gray;
      padding: 4px 8px;
      text-align: start;
    }

    td:first-of-type {
      width: 200px;
    }
  }

  @media print {
    display: block;
  }
}
  `
})
export class PrintNoticeRefusalComponent extends AbstractPrintComponent {
  @Input() data: PrintNoticeData;
  @Output() init: EventEmitter<any> = new EventEmitter<any>();

  constructor(public sync: SyncService, elRef: ElementRef) {
    super(elRef);
  }
}
